<div class="small-chart-widget chart-widgets-small">
   <div class="card">
     <div class="card-header">
       <h5>{{ 'Monthly Sales' | translate }}</h5>
     </div>
     <div class="card-body">
       <div class="chart-container">
         <div class="row">
           <div class="col-12">
             <div id="chart-widget8">
               <apx-chart [fill]="monthlySales.fill" [colors]="monthlySales.colors" [chart]="monthlySales.chart" [series]="monthlySales.series" [title]="monthlySales.title" [stroke]="monthlySales.stroke" [markers]="monthlySales.markers" [labels]="monthlySales.labels"></apx-chart>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>